// extracted by mini-css-extract-plugin
export default {"background":"styles_background__YM17v","animationTrue":"styles_animationTrue__JMqKv","animationFalse":"styles_animationFalse__WFI1K"};